import { isDefinedString, isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../../../../constants/i18n";
import getKhattabatStore from "../../../../../../../stores/khattabat-stores";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";
import getKhattabat101CStore from "../../../../../../../stores/khattabat-stores/101c-stores/index";
import getKhattabat102GeneralStore from "../../../../../../../stores/khattabat-stores/102-stores/general-102-store";

const CreateOneOTwoButton = withLiteObserverAndTheme<{
  userID: number;
}>((props) => {
  const { theme, userID } = props;
  const { unitX, colors } = theme;

  const { userUUID, isVIPKhatabat, insertUserIdField } =
    getKhattabat101CStore(userID);
  const { alkhattabaUUID } = getKhattabatStore();
  const matchUserId = insertUserIdField.get();

  const isValidSubscription = isVIPKhatabat.get();
  const isDisabledButton =
    !isDefinedString(alkhattabaUUID.get()) ||
    !isDefinedString(userUUID.get()) ||
    !isPositiveNumber(matchUserId) ||
    !isValidSubscription;
  return (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        borderRadius: 36 * unitX,
        cursor: isValidSubscription ? "pointer" : "unset",
        overflow: "hidden",
        backgroundColor: isDisabledButton
          ? colors.all.davysGrey
          : colors.all.bondiBlue
      }}
      color={""}
      justifyContent={"center"}
      withShadow={true}
      isExtendable={false}
      isScrollable={false}
      onClick={
        isDisabledButton
          ? null
          : () => getKhattabat102GeneralStore().createOneOTwo(userID)
      }
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get("CREATE_ONE_O_TWO")}
        style={{}}
        color={colors.all.white}
      />
    </ET3Div>
  );
});

export default CreateOneOTwoButton;
